import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { CoreModule } from '@app/core/core.module';
import { PreviewImgComponent } from './preview-img.component';
import { ExercisePreviewCalculationComponent } from '@app/shared/components/preview-img/exercise-preview-calculation/exercise-preview-calculation.component';
import { ExercisePreviewMagicboxComponent } from '@app/shared/components/preview-img/exercise-preview-magicbox/exercise-preview-magicbox.component';
import { ExercisePreviewSequenceComponent } from '@app/shared/components/preview-img/exercise-preview-sequence/exercise-preview-sequence.component';
import { ExercisePreviewTaskComponent } from '@app/shared/components/preview-img/exercise-preview-task/exercise-preview-task.component';
import { TemplateCardComponent } from '@app/shared/components/preview-img/template-card/template-card.component';
import { SharedModule } from '@app/shared/shared.module';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
    imports: [CommonModule, HttpClientModule, FormsModule, SharedModule, CoreModule, MatCheckboxModule],
    declarations: [
        PreviewImgComponent,
        TemplateCardComponent,
        ExercisePreviewCalculationComponent,
        ExercisePreviewMagicboxComponent,
        ExercisePreviewSequenceComponent,
        ExercisePreviewTaskComponent
    ],
    exports: [
        PreviewImgComponent,
        TemplateCardComponent,
        ExercisePreviewCalculationComponent,
        ExercisePreviewMagicboxComponent,
        ExercisePreviewSequenceComponent,
        ExercisePreviewTaskComponent
    ],
    providers: []
})
export class PreviewImgModule {}
